'use client';

import { createContext } from 'react';

import { CurrencyCode, SupportedLocation } from './constants';

type UserLocation = {
  defaultLocation: SupportedLocation;
  location: SupportedLocation;
  getCurrencyCodeByLocation: () => CurrencyCode;
  setLocation: (newLocation: SupportedLocation) => void;
  localisedRoutes: string[];
};

const LocationContext = createContext<UserLocation>({
  defaultLocation: SupportedLocation.US,
  location: SupportedLocation.US,
  getCurrencyCodeByLocation: () => CurrencyCode.USD,
  setLocation: () => null,
  localisedRoutes: [],
});

export { LocationContext };
